(function () {
    'use strict';

    a3_pilot_reports.service("SyncAPIService", SyncAPIService);
    /**
    * @memberof PilotReports
    * @ngdoc service
    * @name SyncAPIService
    * @description 
    * Generic Sync service which sends all your reports and Get all the latest data
    * @ngInject
    */
    function SyncAPIService($http, $q, apiUrl
        , FlightFactory, ReportGuidFactory, PilotReportTemplateFactory, SyncLogFactory, PilotReportLocalEditFactory
        , PilotReportSendToServerFactory, PilotReportSyncResultFactory, AircraftTypeFactory, DataCleanerFactory
        , MessageFactory, LogService, GroundDutyFactory, MemoFactory, PaxInfoFactory, CrewRouteFactory, CrewMealFactory
        , MemoImagesFactory, AircaftPositionsFactory, AimsCrewMemosFactory
        , LeaveRequestFactory, AutolandFactory, CatIIFactory, CrewHotelFactory, CourseFactory, ScheduleAcknowledgeFactory
        , CrewCallFactory, PreviousDutyFactory, LogCallFactory, CheckInFactory, FlightCheckInsFactory, TimeLogFactory
        , AnnualLeavesFactory, ExpiriesFactory, FlightDelaysFactory, TraineeCoursesDetailsFactory, RequestFactory) {
        /**
         * Find if a relative old flight exists and if exists update it 
         * @memberof SyncAPIService
         * @param {object} oldflight
         * @param {array} flights
         * @return {boolean} hasRelativeFlight
         */
        function relativeFlightMatcher(oldflight, flights) {
            var relativeFlights = [];
            var found = false;

            for (var i = 0; i < flights.length; i++) {
                if (oldflight.FlightNo == flights[i].FlightNo && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
                    relativeFlights.push(flights[i]);
                    found = true;
                    break;
                }
            }

            if (!found) {
                var flight = null;
                var oldFlightNo = null;
                var lastDigit = oldflight.FlightNo.substr(oldflight.FlightNo.length - 1, 1)

                oldFlightNo = (!isNaN(lastDigit)) ? oldflight.FlightNo : oldflight.FlightNo.substr(0, oldflight.FlightNo.length - 1);


                for (var i = 0; i < flights.length; i++) {
                    lastDigit = flights[i].FlightNo.substr(flights[i].FlightNo.length - 1, 1);

                    flight = (!isNaN(lastDigit)) ? flights[i].FlightNo : flights[i].FlightNo.substr(0, flights[i].FlightNo.length - 1);

                    if (oldFlightNo == flight && oldflight.FlightDate == flights[i].FlightDate && oldflight.Departure == flights[i].Departure) {
                        relativeFlights.push(flights[i]);
                    }
                }
            }

            if (relativeFlights.length == 1) {
                var pilotReportLocalEdit = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(oldflight.FlightId);
                pilotReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
                pilotReportLocalEdit.FlightId = relativeFlights[0].FlightId;
                PilotReportLocalEditFactory.setPilotReportToStorage(pilotReportLocalEdit);

                return true;
            } else if (relativeFlights.length > 1) {
                for (var i = 1; i < relativeFlights.length; i++) {
                    for (var j = 0; j < relativeFlights.length - i; j++) {
                        if (relativeFlights[j].FlightNo > relativeFlights[j + 1].FlightNo) {
                            var a = relativeFlights[j];
                            relativeFlights[j] = relativeFlights[j + 1];
                            relativeFlights[j + 1] = a;
                        }
                    }
                }

                var pilotReportLocalEdit = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(oldflight.FlightId);
                pilotReportLocalEdit.FlightAimsId = relativeFlights[0].FlightAimsId;
                pilotReportLocalEdit.FlightId = relativeFlights[0].FlightId;
                PilotReportLocalEditFactory.setPilotReportReportToStorage(pilotReportLocalEdit);

                return true;
            } else {

                return false;
            }


        };
        return {
            /**
             * Send and get the latest information 
             * @memberof SyncAPIService
             * @param {object} aimsId
             * @param {array} memoIdsToSend 
             */
            doSync: function (aimsId, memoIdsToSend) {
                //Clear timeLogs from local storage older than 2 days
                TimeLogFactory.cleanOldData();
                //clear CrewMeal ratings from local storage that have timestamp older than 20 days
                DataCleanerFactory.deleteOldCrewMealsRatings();

                // get the saved pilot reports
                var allSavedReports = PilotReportLocalEditFactory.getPilotReportsFromStorage();

                // keep only the ones that are ready to be sent
                var reportsToSend = PilotReportSendToServerFactory.getCompletedListFromPilotReportLocalEdits(allSavedReports);
                var messagesToSend = MessageFactory.getMessagesFromStorage();

                var lastLog = SyncLogFactory.getSyncLog();
                var lastSyncDate = lastLog.date;

                //Get call requests made while offline
                var phoneCallLog = {
                    CrewCallReports: LogCallFactory.getLogCallsFromStorage()
                }

                var syncData = {
                    "SyncPilotReports": reportsToSend,
                    "Messages": messagesToSend,
                    "MemoIds": memoIdsToSend,
                    "CrewCallLog": phoneCallLog,
                    "LastSyncDate": lastSyncDate
                };

                var call = $q.defer();

                $http.post(apiUrl + '/sync', syncData, { 'Content-Type': 'application/json' })
                    .then(
                        function (responseData) {
                            if (responseData == undefined
                                || responseData.data == undefined
                                || responseData.data.data == undefined
                                || responseData.data.data.SyncPilotData == undefined) {
                                var err = new Error();
                                err.status = -1;
                                var msg = "ResponseData error in sync :" + JSON.stringify(responseData);
                                LogService.debug(msg, err)
                                call.reject(err);
                                return;
                            }
                            var response = responseData.data.data;

                            //keep flights, will be used to retain a flight for old unsynched reports
                            var orgFlights = FlightFactory.getFlightsFromStorage();

                            // clear existing server data
                            FlightFactory.clearFlightsFromStorage();
                            ReportGuidFactory.clearReportGuidsFromStorage();
                            PilotReportTemplateFactory.clearPilotReportTemplateFromStorage();
                            AircraftTypeFactory.clearAircraftTypesFromStorage();
                            PilotReportSyncResultFactory.clearPilotReportSyncResultsFromStorage();
                            MessageFactory.clearMessagesFromStorage();
                            AimsCrewMemosFactory.clearAimsCrewMemosFactoryFromStorage();

                            // save flight data to local storage
                            var flightData = response.SyncPilotData.flights;
                            var flights = FlightFactory.markScheduleChangedFlights(flightData, orgFlights);

                            var pilotReports = response.SyncPilotData.pilotReports;
                            var cabinReports = response.SyncPilotData.cabinReports;
                            var messages = response.SyncPilotData.messages;

                            for (var i = 0; i < messages.length; i++) {
                                messages[i].AuthorName = messages[i].AuthorName.replace("GATEWAY\\", "");
                                messages[i].AuthorName = messages[i].AuthorName.replace(".", " ");
                            }

                            MessageFactory.setMessagesToStorage(messages);

                            var fromSync = true;
                            GroundDutyFactory.mergeGroundDutiesToStorage(response.SyncPilotData.groundDuties, fromSync);
                            CrewRouteFactory.setCrewRoutesToStorage(response.SyncPilotData.CrewRoutes);
                            CrewMealFactory.setCrewMealsToStorage(response.SyncPilotData.CateringCrewMeals);
                            CrewHotelFactory.setCrewHotelsToStorage(response.SyncPilotData.CrewHotels);
                            CheckInFactory.setCheckInInfoToStorage(response.CrewCheckInInfo);
                            AnnualLeavesFactory.setAnnualLeavesToStorage(response.AnnualLeaves);
                            ExpiriesFactory.setCrewExpiriesToStorage(response.CrewExpiries);
                            AimsCrewMemosFactory.setAimsCrewMemosToStorage(response.SyncPilotData.aimsCrewMemos)    
                         
                            ExpiriesFactory.setAllExpiriesToStorage(response.AllExpiries);      
                                         
                       
                            //Save schedule changes dates 
                            ScheduleAcknowledgeFactory.setAllScheduleChangesToStorage(response.SyncPilotData.ScheduleChanges)

                            if(response.RosterRequestAncillaries){
                                RequestFactory.setSubmissionDeadlineDateToStorage(response.RosterRequestAncillaries.SubmissionEndDate);
                            }

                            //clean crew call logs
                            if (response.SyncPilotData.CrewCallLog && response.SyncPilotData.CrewCallLog.ResponseSuccess) {
                                LogCallFactory.cleanLogsFromStorage();
                            } 

                            //save training courses
                            var rawTrainingCourses = response.SyncPilotData.TrainingCourses;
                            var courses = [];

                            rawTrainingCourses.forEach(function (course) {
                                courses.push({
                                    Id: course.PhaseId !== undefined ? course.Id + "_" + course.PhaseId : course.Id,
                                    Title: course.Title,
                                    CourseId: course.Id,
                                    PhaseId: course.PhaseId,
                                    PhaseTitle: course.PhaseTitle,
                                    HasLimitedInfo: true
                                });
                            });

                            CourseFactory.setCoursesFromServer(courses);

                            //clean crew member info
                            var responseFlightIds = response.SyncPilotData.flights.map(x => x.FlightId);
                            CrewCallFactory.cleanOldData(responseFlightIds);
                            PreviousDutyFactory.cleanOldData(responseFlightIds);
                            FlightCheckInsFactory.cleanOldData(responseFlightIds);
                            AircaftPositionsFactory.cleanOldData(responseFlightIds);
                            //AimsCrewMemosFactory.cleanOldAimsCrewMemos();

                            AutolandFactory.setAutolandToStorage(response.SyncPilotData.AutolandOperations, flightData);
                            CatIIFactory.setCatIIToStorage(response.SyncPilotData.CatIIOperations, flightData);

                            var pendingFlightIds = PilotReportLocalEditFactory.getFlightIdsWithPendingReports();
                            PaxInfoFactory.cleanOldDataPaxInfo(pendingFlightIds);
                            //Data cleaner for flight delays
                            FlightDelaysFactory.cleanOldFlightDelays(responseFlightIds);

                            //save, update or add   memos
                            var memos = response.SyncPilotData.memos;
                            MemoFactory.setMemosFromServer(memos, memoIdsToSend, lastSyncDate);

                            //delete leftover memos
                            var serverMemoIds = response.SyncPilotData.memoIds;
                            for (var i = 0; i < serverMemoIds.length; i++) {
                                MemoFactory.deleteMemoFromStorage(serverMemoIds[i]);
                            }

                            for (var i = 0; i < memos.length; i++) {
                                MemoImagesFactory.deleteMemoImageByMemoId(memos[i].Id);
                            }

                            var images = response.SyncPilotData.Images;
                            MemoImagesFactory.setImagesToServer(images);

                            for (var i = 0; i < serverMemoIds.length; i++) {
                                MemoImagesFactory.deleteMemoImageByMemoId(serverMemoIds[i]);
                            }

                            // save guids to local storage
                            var reportGuids = response.SyncPilotData.guids;
                            ReportGuidFactory.setReportGuidsToStorage(reportGuids);

                            var traineeCourses = response.SyncPilotData.TraineeCourses;
                            TraineeCoursesDetailsFactory.setTraineeCoursesToStorage(traineeCourses);

                            var traineeFlightCourses = response.SyncPilotData.TraineeFlightCourses;
                            TraineeCoursesDetailsFactory.setTraineeFlightCoursesToStorage(traineeFlightCourses);

                            // save pilot report template to storage
                            var pilotReportTemplate = response.SyncPilotData.pilotReportTemplate;
                            PilotReportTemplateFactory.setPilotReportTemplateToStorage(pilotReportTemplate);

                            // save aircraft types to local storage
                            var aircraftTypes = response.SyncPilotData.aircraftTypes;
                            AircraftTypeFactory.setAircraftTypesToStorage(aircraftTypes);

                            // get the sync results
                            var syncResults = PilotReportSyncResultFactory.fromObjectList(response.SyncPilotData.reportResults);

                            // mark sent reports as synched
                            for (var j = 0; j < reportsToSend.length; j++) {
                                var syncResult = PilotReportSyncResultFactory.getSyncResult(syncResults, reportsToSend[j].ReportGuid);

                                if (syncResult != null) {
                                    if (syncResult.success) {
                                        PilotReportLocalEditFactory.markReportAsSynched(reportsToSend[j].ReportGuid);
                                        syncResult.Result = 'Successfully submitted';
                                    } else {
                                        syncResult.Result = 'Submission error';
                                    }

                                    // find flight and append report fields (storage cleared: use orgFlight)
                                    var flight = null;
                                    if (orgFlights != null) {
                                        for (var i = 0; i < orgFlights.length; i++) {
                                            if ((orgFlights[i].FlightId != null && orgFlights[i].FlightId == reportsToSend[j].FlightId) || (orgFlights[i].FlightAimsId != null && orgFlights[i].FlightAimsId == reportsToSend[j].FlightAimsId)) {
                                                flight = orgFlights[i];
                                                break;
                                            }
                                        }
                                    }
                                    //var flight = FlightFactory.getFlightFromStorage(reportsToSend[j].FlightAimsId);

                                    if (flight != null) {
                                        syncResult.FlightAimsId = flight.FlightAimsId;
                                        syncResult.FlightId = flight.FlightId;
                                        syncResult.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                                        syncResult.FlightNo = flight.FlightNo;
                                        syncResult.Departure = flight.Departure;
                                        syncResult.Arrival = flight.Arrival;
                                        syncResult.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                                        syncResult.AcTailNo = flight.AcTailNo;
                                    }
                                }
                            }

                            // save the sync results
                            PilotReportSyncResultFactory.setPilotReportSyncResultsToStorage(syncResults);

                            // log the sync user and date
                            SyncLogFactory.setSyncLog(aimsId, response.SyncPilotData.version, response.SyncPilotData.toDate);

                            // delete local flights with no local reports
                            DataCleanerFactory.deleteOrphanedLocalFlights();

                            LeaveRequestFactory.saveLeaveRequestInformation(response.SyncPilotData.LeaveRequestInformation);

                            //**************** ADD CODE TO KEEP FLIGHTS IF THEY STIL HAVE AN NOT SYCNHED REPORT *********************//
                            //find flight ids used by draft or completed (not synched for some reason) reports
                            if (allSavedReports) {
                                var verifyFlightAimsIds = [];
                                var verifyFlightIds = [];
                                for (var i = 0; i < allSavedReports.length; i++) {
                                    if (allSavedReports[i].Status == 'draft' || allSavedReports[i].Status == 'completed')
                                        verifyFlightAimsIds.push(allSavedReports[i].FlightAimsId);
                                    verifyFlightIds.push(allSavedReports[i].FlightId);
                                }
                                //search these ids into the newly received flights
                                if (verifyFlightAimsIds.length > 0) {
                                    var missingIds = [];
                                    var missingAimsIds = [];
                                    var found, id, aimsId;
                                    for (var i = 0; i < verifyFlightAimsIds.length; i++) {
                                        found = false;
                                        aimsId = verifyFlightAimsIds[i];
                                        id = verifyFlightIds[i];
                                        for (var f = 0; f < flights.length; f++) {
                                            if ((flights[f].FlightId != null && flights[f].FlightId == id) || (flights[f].FlightAimsId != null && flights[f].FlightAimsId == aimsId)) {
                                                found = true;
                                                break;
                                            }
                                        }
                                        if (!found)
                                            missingIds.push(id);
                                        missingAimsIds.push(aimsId);
                                    }
                                    //search missing flights in flights stored before sync
                                    if (orgFlights) {
                                        for (var m = 0; m < missingIds.length; m++) {
                                            id = missingIds[m];
                                            aimsId = missingAimsIds[m];
                                            for (var o = 0; o < orgFlights.length; o++) {
                                                if ((orgFlights[o].FlightId != null && orgFlights[o].FlightId == id) || (orgFlights[o].FlightAimsId != null && orgFlights[o].FlightAimsId == aimsId)) {
                                                    if (!relativeFlightMatcher(orgFlights[o], flights)) {
                                                        flights.push(orgFlights[o]);
                                                    }
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            //FlightFactory.setFlightsToStorage(flights);
                            FlightFactory.storeFlightsWithReportsAndMessages(flights, pilotReports, cabinReports, messages);
                            // return true
                            call.resolve(responseData);
                        },
                        function (err) {
                            call.reject(err);
                        }
                    );
                return call.promise;
            },
            /**
             * Update local reports from synced Fligths 
             * @memberof SyncAPIService
             */
            updatePilotReportLocalEditFromSynch: function () {
                var pilotReportLocalEdits = PilotReportLocalEditFactory.getPilotReportsFromStorage();
                if (pilotReportLocalEdits != undefined && pilotReportLocalEdits != null) {
                    for (var i = 0; i < pilotReportLocalEdits.length; i++) {
                        var flight = FlightFactory.getFlightFromStorage(pilotReportLocalEdits[i].FlightId, pilotReportLocalEdits[i].FlightAimsId);
                        if ((pilotReportLocalEdits[i].Status == "draft" || pilotReportLocalEdits[i].Status == "completed") && (flight != undefined)) {

                            pilotReportLocalEdits[i].Departure = flight.Departure;
                            pilotReportLocalEdits[i].Arrival = flight.Arrival;
                            pilotReportLocalEdits[i].AcType = flight.AcType;
                            pilotReportLocalEdits[i].AcTailNo = flight.AcTailNo;
                            pilotReportLocalEdits[i].FlightNo = flight.FlightNo;
                            pilotReportLocalEdits[i].DepartureICAO = flight.DepartureICAO;
                            pilotReportLocalEdits[i].DepartureCountry = flight.DepartureCountry;
                            pilotReportLocalEdits[i].DepartureName = flight.DepartureName;
                            pilotReportLocalEdits[i].ArrivalICAO = flight.ArrivalICAO;
                            pilotReportLocalEdits[i].ArrivalCountry = flight.ArrivalCountry;
                            pilotReportLocalEdits[i].ArrivalName = flight.ArrivalName;
                            pilotReportLocalEdits[i].ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
                            pilotReportLocalEdits[i].ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
                            pilotReportLocalEdits[i].ScheduledDeparture = flight.ScheduledDeparture;
                            pilotReportLocalEdits[i].BookedC = flight.BookedC;
                            pilotReportLocalEdits[i].BookedY = flight.BookedY;
                            pilotReportLocalEdits[i].BookedInf = flight.BookedInf;
                            pilotReportLocalEdits[i].BookedPad = flight.BookedPad;
                            pilotReportLocalEdits[i].BookedChld = flight.BookedChld;
                            pilotReportLocalEdits[i].ActualC = flight.ActualC;
                            pilotReportLocalEdits[i].ActualY = flight.ActualY;
                            pilotReportLocalEdits[i].ActualInf = flight.ActualInf;
                            pilotReportLocalEdits[i].ActualPad = flight.ActualPad;
                            pilotReportLocalEdits[i].ActualChld = flight.ActualChld;

                            pilotReportLocalEdits[i].DepartureGate = flight.DepartureGate;
                            pilotReportLocalEdits[i].DepartureTimezone = flight.DepartureTimezone;
                            pilotReportLocalEdits[i].ArrivalTimezone = flight.ArrivalTimezone;
                            pilotReportLocalEdits[i].CallSign = flight.CallSign;
                            pilotReportLocalEdits[i].ScheduledArrival = flight.ScheduledArrival;



                            pilotReportLocalEdits[i].crew = flight.crew;

                        }
                    }
                    PilotReportLocalEditFactory.setPilotReportsToStorage(pilotReportLocalEdits);
                }
            }
        };
    }



})();